import { MonthModal } from './MonthModal';

export default MonthModal;
